import "./career-tile.scss";

import React from "react";
import { Link } from "gatsby";

const CareerTile = ({ jobName, description, link, date, image }) => {
  return (
    <div className="career-tile">
      <div
        className="career-tile__image"
        style={{ backgroundImage: `url(${image})` }}
      />
      <div className="career-tile__text-container">
        <h4 className="career-tile__job-name">{jobName}</h4>
        <div className="career-tile__desc">{description}</div>
        <Link to={link} className="career-tile__link btn btn--text">
          zobacz ofertę
        </Link>
        <div className="career-tile__date">dodano: {date}</div>
      </div>
    </div>
  );
};

export default CareerTile;
